import { useQuery } from "@tanstack/react-query"
import { profile } from "@shared/api/services"

export const useAnalytics = () => {
	return useQuery({
		queryKey: ['analytics'],
		queryFn: () => profile.getAnalytics(),
		select: (data) => data.data
	})
}